import './chat.css';
import React, { useState, useEffect } from 'react';
import pisi from'../../images/pisi.png'

function Chat({mess, from, goNext, goNextOnI, goMenu, gallery, setGallery, setFailedGame}) {
  const [messages, setMessage] = useState([]);
  const [answers, setAnswers] = useState();
  const [myAnswers, setMyAnswers] = useState([]);
  const [opacity, setOpacity] = useState(0);
  const [white, setWhite] = useState(1);
  const [messNum, setMessNum] = useState(0);
  const [value, setValue] = useState();
  const [failer, setFailer] = useState();
    const [next, setNext] = useState();
    const [nextOnI, setNextOnI] = useState();
    const [index, setIndex] = useState(20);
  let answered, newGallery;

  useEffect(() => {
     newGallery = new Map(gallery);
  });

  useEffect(() => {
    start(messNum);
    changeWhite(true);
},[]);

useEffect(() => {
  var d = document.getElementById('messages');
console.log(d.scrollHeight);
console.log(d.clientHeight);

if(d.scrollHeight > d.clientHeight) {
d.scrollTop = d.scrollHeight - d.clientHeight;
}
});

async function go(){
  setIndex(20);
  if(failer !== undefined){
    localStorage.setItem('failedGame', failer);
    setFailedGame(failer);
  }
  await changeWhite();
  goNext();
}

async function goOnI(){
  setIndex(20);
  await changeWhite();
  goNextOnI(3);
}

async function goToMenu(){
  setIndex(20);
  await changeWhite();
  goMenu();
}
function changeWhite(toLow){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
      console.log(opacity);
        console.log(op);
  if(toLow){
    if(op>0){
      op-=0.03;
    setWhite(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setWhite(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}

const onChange = (e) => {
  setValue(e.target.value);
};

async function myAnswer(e){
await ans();


  function ans(){
        return new Promise((resolve, reject) => {
            setIndex(18);
            changeOpacity(true);
            if(!e.target.src && e.target.innerHTML.indexOf("<img src=") === -1){
            setMessage([...messages, {text:e.target.innerHTML, from: 'messageFromMe'}]);
            answered=e.target.innerHTML;
          }else{
            if(e.target.src){
              setMessage([...messages, {img:e.target.src, height:"300px", from: 'messageFromMe'}]);
              answered="/static" + e.target.src.split("/static")[1];
          }else{
            setMessage([...messages, {img:e.target.childNodes[0].src, height:"300px", from: 'messageFromMe'}]);
            answered="/static" + e.target.childNodes[0].src.split("/static")[1];
          }
          }
            start(messNum);
            resolve();
          });
        }
}

function waitin(){
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
function ff(){
  resolve();
}
  });
}

async function start(startingFrom){
  for(let i=startingFrom;i<mess.length;i++){
    if(mess[i].answered){
            if(answered !== undefined && answered.indexOf("/static/media/") !==-1){
      answered = answered.split("/static/media/")[1];
      }
      if(mess[i].answered.indexOf("/static/media/") !==-1){
      mess[i].answered = mess[i].answered.split("/static/media/")[1];
      }
      if(answered !== mess[i].answered){
        if(mess[i].endofAnswer){
          answered=undefined;
        }
        continue;
      }
      if(mess[i].endofAnswer){
        answered=undefined;
      }
    }
    if(mess[i].failGame){
      setFailer(1);
    }else if(mess[i].unFailGame){
      setFailer(0);
    }
    let delay;
    if(mess[i].img){
      delay = 3;
    }else if(mess[i].audio){
      delay = 3;
    }else{
      delay = Math.floor(mess[i].text.length / 40);
      if(delay===0) delay=1;
      console.log(delay)
    }
await typAnim(delay, mess[i]);
delay=0;
setMessNum(i+1);
await waitin();
if(mess[i].answers){
  break;
}
if(mess[i].endOfChat){
  break;
}
if(mess[i].skipAnswers){
  answered=undefined;
}
  }
}

function changeOpacity(toLow){
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
      console.log(opacity);
        console.log(op);
  if(toLow){
    if(op>0){
      op-=0.1;
    setOpacity(op);
    setTimeout(ChangetoLow, 20);
  }else{
    setAnswers(undefined);
    return;
  }
}else{
  if(op<1){
    op+=0.1;
  setOpacity(op);
  setTimeout(change, 20);
}else{
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
}
  function typAnim(end,message){
    return new Promise((resolve, reject) => {
    let i=0,j=0;
    if(message.img && message.gallery){
      if(gallery.has(message.img)){
        if(gallery.get(message.img) !== "1"){
        newGallery.set(message.img, '1');
        localStorage.setItem('gallery', JSON.stringify(Array.from(newGallery.entries())));
        setGallery(newGallery);
      }
      }
    }
    if(message.from === 'messageFromMe'){
      j=end;
    }
    anim();
    async function anim(){
      try{
      if(j===end){
      setMessage((prev) => [...prev, message]);
        if(message.answers){
          setIndex(14);
          document.getElementById('typ').innerHTML = "Online";
          await waitin();
          setAnswers(message.answers);
          changeOpacity(false);
        }
        if(message.endOfChat){
          if(message.endOfChat.skip){
            setTimeout(setNextOnIWithDelay, 2000)
          }else{
          setTimeout(setNextWithDelay, 2000)
          }
        }
        function setNextOnIWithDelay(){
          setIndex(14);
          setNextOnI({text: message.endOfChat.text});
        }
        function setNextWithDelay(){
          setIndex(14);
          setNext({text: message.endOfChat.text});
        }
        document.getElementById('typ').innerHTML = "Online";
          resolve()
          return;

        }
      if(i===0){
        if(message.img && !message.fake){
    document.getElementById('typ').innerHTML = "sending a photo...";
  }else if(message.audio || message.fake){
    document.getElementById('typ').innerHTML = "recording an audio...";
  }else{
    document.getElementById('typ').innerHTML = "typing...";
  }
  i++;
    setTimeout(anim,200);
  return;
}
if(i===1){
  if(message.img && !message.fake){
    document.getElementById('typ').innerHTML = "sending a photo.";
  }else if(message.audio || message.fake){
    document.getElementById('typ').innerHTML = "recording an audio.";
  }else{
    document.getElementById('typ').innerHTML = "typing.";
  }
i++;
  setTimeout(anim,200);
    return;
}
if(i===2){
  if(message.img && !message.fake){
    document.getElementById('typ').innerHTML = "sending a photo..";
  }else if(message.audio || message.fake){
    document.getElementById('typ').innerHTML = "recording an audio..";
  }else{
    document.getElementById('typ').innerHTML = "typing..";
  }
  j++;
  i=0;
    setTimeout(anim,200);
  return;
}
}catch(e){
  console.log(e);
}
}
});
  }
  return (
<div className='wrap'>
{next && <div className='nextDay' onClick={go}><p>{next.text}</p></div>}
{nextOnI && <div className='nextDay' onClick={goOnI}><p>{nextOnI.text}</p></div>}
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
{/*<div className='nextDay'><p>NEXT DAY ></p></div>
<div className='type'><input type='text' placeholder='Type ur name' onChange={onChange}/> </div>*/}
{ answers &&
<div className='answers' style={{opacity:opacity}}>
{answers.map((item,index)=>{
  return (
    <div className='answer' onClick={myAnswer} name={index} key={index}>{item.img? <img src={item.img} height="100px"/> : item}</div>
  )
})}
</div>
}
<img src={pisi} className='logo'/>
<div className='topLine'>
<div className="arrow1" onClick={goToMenu}>
    <div></div>
</div>
<div className='pict'>
  <img className='img' src={from.photo} alt="" />
</div>
<div>
<p className='name'>{from.name}</p>
<p className='typ' id="typ">Online</p>
</div>

</div>
<div id='back'></div>
<div className='messages' id='messages'>
{ messages.map(function (item, index) {
return(
  <div className={item.audio || item.fake? item.from+'Audio':item.from} key={index}>
  <div className={item.from+'Under'}></div>
  {item.text && <p className="comment_text">{item.text}</p>}
  {item.img && <img src={item.img} height={item.height} max-width='100%'/>}
  {item.audio && <><div className='angle lefttop'></div><div className='angle leftbottom'></div><div className='angle rightbottom'></div><div className='angle righttop'></div><audio id="audio" src={item.audio} controls autoPlay></audio></>}
  </div>
);

})
}
</div>
</div>
  );
}

export default Chat;
